exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .mat-dialog-container {\n  padding: 0 !important; }\n\n.category-form {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding: 24px; }\n  .category-form mat-form-field {\n    width: 100%; }\n  .category-form .submit-button {\n    margin-top: 15px; }\n    .category-form .submit-button button {\n      float: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/categories-panel/dialogs/add-edit-category-dialog/add-edit-category-dialog.component.scss
// module id = ../../../../../src/app/components/admin/components/categories-panel/dialogs/add-edit-category-dialog/add-edit-category-dialog.component.scss
// module chunks = main